export const DEFAULT_PRODUCT_CARD_HEIGHT = 216

const animateScroll = (target, offset, duration, initalPosition = window.scrollY, startedAt = new Date().getTime()) => {
  requestAnimationFrame(() => {
    const currentTime = new Date().getTime()
    const progress = (currentTime - startedAt) / duration
    const finalPosition = target.getBoundingClientRect().top + window.scrollY - offset
    const deltaPosition = initalPosition + (finalPosition - initalPosition) * progress

    window.scrollTo({
      top: progress < 1 ? deltaPosition : finalPosition,
    })

    if (progress <= 1) {
      animateScroll(target, offset, duration, initalPosition, startedAt)
    }
  })
}

export const handleScrollTo = (id, offset) => {
  const element = document.querySelector(`#${id}`)
  if (!element) return
  animateScroll(element, offset, 300)
}
